export default __webpack_public_path__ + "static/media/skovstykket-floorplans-townhouse-5-rooms.06796f3d.jpg";